export default __webpack_public_path__ + "static/media/library_hidef.d7a878cb.PNG";